import PropTypes from 'prop-types';
import cx from 'classnames';
import { defineMessages, useIntl } from 'react-intl';
import MaybeWrap from '@plone/volto/components/manage/MaybeWrap/MaybeWrap';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import Icon from '../../Icon';

const messages = defineMessages({
  empty: {
    id: 'Use the sidebar to add some cards',
    defaultMessage: 'Use the sidebar to add some cards',
  },
});

const CardsBody = (props) => {
  const { data, isEditMode } = props;
  const {
    cards,
    cardsPerRow = 4,
    cardsPerRowOnMobile = 1,
    align,
    label: globalLabel,
    style: globalStyle,
  } = data;
  const intl = useIntl();

  if (!cards || !cards.length) {
    return (
      <div style={{ textAlign: 'center' }}>
        {intl.formatMessage(messages.empty)}
      </div>
    );
  }

  return (
    <div className={'card-block'}>
      <div className={cx('wrap', `mobile-${cardsPerRowOnMobile}`)}>
        {cards.map((card, idx) => {
          const {
            style = globalStyle,
            icon,
            title,
            description,
            href,
            label,
            openLinkInNewTab,
          } = card;

          const cardStyle = cx(`card-${cardsPerRow}`, align);

          if (!icon && !title && !description && !href && isEditMode) {
            return (
              <div className={cardStyle} key={idx}>
                <div className={'placeholder'}>
                  <div className={'phIcon'} />
                  <div className={'phTitle'} />
                  <div className={'phDesc'} />
                  <div className={'phDesc'} />
                </div>
              </div>
            );
          }

          return (
            <div key={idx} className={cardStyle}>
              <MaybeWrap
                condition={href?.length}
                as={UniversalLink}
                openLinkInNewTab={openLinkInNewTab}
                className={'inner'}
                href={href?.length && !isEditMode ? href[0]['@id'] : null}
              >
                <MaybeWrap
                  condition={!href?.length}
                  as="div"
                  className={'inner'}
                >
                  {icon ? (
                    <div className={'icon-wrapper'}>
                      <Icon name={icon} className={cx('icon', style)} />
                    </div>
                  ) : null}
                  {title ? <div className={'title'}>{title}</div> : null}
                  {description ? (
                    <div className={'desc'}>{description}</div>
                  ) : null}
                  {href?.length && (label || globalLabel) ? (
                    <span className="more-link">{label || globalLabel}</span>
                  ) : null}
                </MaybeWrap>
              </MaybeWrap>
            </div>
          );
        })}
      </div>
    </div>
  );
};

CardsBody.propTypes = {
  isEditMode: PropTypes.bool,
};

export default CardsBody;
